


















import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import request from "../../../api/request";
import Api from "../../../api";
import { Tree } from "element-ui";

@Component({
  name: "LeftTree"
})
export default class LeftTree extends Vue {
  @Prop({ type: String, default: "" }) viewId!: string;
  @Prop({ type: String, default: "" }) prefix!: string;

  treeData: Record<string, any>[] = [];
  treeProps: Record<string, string | boolean> = {
    label: "fieldName",
    value: "fieldValue",
    valuePrefix: "",
    ifRecursiveSearch: false
  };
  isSingleCheck: boolean = false;
  lastCheckedNodeId: string = ""; // 记录上次选中的节点ID
  treeAttrs: Record<string, any> = {};
  treeListeners: Record<string, any> = {
    // checkChange: this.handelCheckChange,
    "current-change": this.handelCurrentChange
  };
  async getTreeData() {
    const { success, message, data } = await request({
      url: this.prefix + Api.getPrimarySearchTree(this.viewId),
      method: "get"
    });
    if (!success) {
      this.$message.error("查询流程包信息失败:" + message);
    }

    if (Array.isArray(data.treNodes)) {
      // this.treeData = this.composeTreeData(data.treNodes, "treeId", "treePid");
      this.treeData = data.treNodes;
      this.treeProps.label = "fieldName";
      this.treeProps.value = "fieldValue";
      this.treeProps.valuePrefix = data.meta.valuePrefix;
      this.treeProps.ifRecursiveSearch = data.ifRecursiveSearch;

      // const whiteList = {
      //   dictionaries: true,
      //   selectors: true,
      //   areas: true,
      //   corporates: true,
      //   departments: true,
      //   posts: true,
      //   roles: true,
      //   users: true
      // };

      // this.isSingleCheck = !!whiteList[data.meta.fieldType as keyof typeof whiteList];
      // this.isSingleCheck = true;
      if (!this.isSingleCheck) {
        this.treeAttrs = {
          "highlight-current": true
        };
      } else {
        this.treeAttrs = {
          "check-on-click-node": false,
          "check-strictly": true,
          "show-checkbox": true
        };
      }
    }
  }
  async getPrimarySearchSql(fieldValue: string) {
    const { success, message, data } = await request({
      url: this.prefix + Api.getPrimarySearchSql(this.viewId),
      method: "get",
      params: {
        fieldValue
      }
    });
    if (!success) {
      this.$message.error("查询流程包信息失败:" + message);
    }
    return data;
  }
  composeTreeData(data: Record<string, any>[], key: string, pKey: string) {
    //删除所有的children,以防多次调用
    data.forEach((item: Record<string, any>) => {
      delete item.children;
    });
    // 将数据存储为 以 id 为 KEY 的 map 索引数据列
    let map: Record<string, any> = {};
    data.forEach((item: Record<string, any>) => {
      map[item[key]] = item;
    });
    let val: Record<string, any>[] = [];
    data.forEach((item: Record<string, any>) => {
      // 以当前遍历项，的pid,去map对象中找到索引的id
      var parent = map[item[pKey]];
      if (parent) {
        (parent.children || (parent.children = [])).push(item);
      } else {
        val.push(item);
      }
    });
    return val;
  }

  @Watch("viewId", { immediate: true })
  private getData(newVal: any) {
    if (newVal) {
      this.getTreeData();
    }
  }

  handelCheckChange(node: any, checked: boolean) {
    if (this.isSingleCheck && checked) {
      (this.$refs.treeRef as Tree).setCheckedKeys([node.treeId], true);
    }

    // 获取当前所有选中的节点
    this.$nextTick(() => {
      const checkedKeys = (this.$refs.treeRef as Tree).getCheckedKeys();
      if (checkedKeys.length > 0) {
        this.$emit("node-click", `${this.treeProps.valuePrefix}${checkedKeys.join(",")}`);
      } else {
        this.$emit("node-click", "");
      }
    });
  }

  // 递归收集节点及其所有子节点的fieldValue
  collectFieldValues(node: any): string[] {
    const values: string[] = [];

    // 添加当前节点的fieldValue
    if (node.fieldValue) {
      values.push(node.fieldValue);
    }

    // 递归处理子节点
    if (node.children && Array.isArray(node.children)) {
      for (const child of node.children) {
        values.push(...this.collectFieldValues(child));
      }
    }

    return values;
  }

  async handelCurrentChange(node: any) {
    const data = await this.getPrimarySearchSql(node.fieldValue);
    this.$emit("node-click", data);
  }
}
